module.exports = {
  "transferred-devicecount-devices-to-targetgroup": "Übertragene {{Gerätezahl}} Geräte an: {{Zielgruppe}}",
  "mac-address": "MAC-Addresse",
  "export-device-list": "Geräteliste exportieren"
}
;